import { Place, WithContext } from 'schema-dts';
import { TransformedEmMap } from '~/transforms/transformModules';

/**
 * Generates locations JSON-LD schema for Geiger Gruppe locations
 * @param data Transformed EmMap data
 * @returns Locations schema object
 */
export function generateLocationsSchema(data: TransformedEmMap['data']): WithContext<any> {
  if (!data.map?.locations?.length) {
    return {};
  }
  return {
    '@context': 'https://schema.org',
    '@graph': data.map.locations?.map(loc => ({
      '@type': 'Place',
      name: loc.name || '',
      address: {
        '@type': 'PostalAddress',
        streetAddress: loc.address || '',
        addressLocality: loc.city || '',
        addressCountry: loc.country || '',
      },
      geo: loc.position
        ? {
            '@type': 'GeoCoordinates',
            latitude: loc.position.lat,
            longitude: loc.position.lng,
          }
        : undefined,
      image: loc.logo || undefined,
      url: loc.approachUrl || undefined,
      sameAs: loc.links?.map(link => link.url) || undefined,
      // Optionally include business areas as keywords
      keywords: loc.businessareas?.join(', ') || undefined,
    })),
  };
}
